import { Link } from "react-router-dom";
import { actors } from "@/mocks/actors";
import type { Actor } from "@/types";
import PageHeader from "@/components/base/PageHeader";
import { usePageMeta } from "@/hooks/usePageMeta";

const list = actors as Actor[];

export default function ActorsList() {
  usePageMeta(
    "演员介绍 - 漂亮的保姆",
    "漂亮的保姆演员介绍栏目，汇总剧中主要演员资料、个人简介与出演作品，帮助你快速了解熟悉的面孔。",
    "漂亮的保姆,演员介绍,演员资料,电视剧演员,影视剧资讯",
  );

  return (
    <>
      <PageHeader
        title="演员介绍"
        desc="汇总热播剧集中的主要演员资料、个人简介与出演作品，点击即可查看完整介绍。"
        crumbs={[{ label: "首页", to: "/" }, { label: "演员介绍" }]}
      />
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {list.map((actor) => (
            <Link
              key={actor.id}
              to={`/actor/${actor.id}`}
              className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-full aspect-square overflow-hidden bg-background-200">
                <img
                  src={actor.avatar}
                  alt={actor.name}
                  title={`${actor.name} - 漂亮的保姆`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 text-center">
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {actor.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  {actor.region} · {actor.height}
                </p>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                  代表作 {actor.works.length} 部
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}